module.exports = __webpack_public_path__ + "img/variedades-aby-logo.31a9bcee.jpg";